var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'run'),expression:"status === 'run'"}],staticClass:"character run",style:({
            backgroundImage: ("url(" + (_vm.url.run) + ")"),
            backgroundPositionX: ((_vm.posX.run) + "px")
         })}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'stand'),expression:"status === 'stand'"}],staticClass:"character stand",style:({
            backgroundImage: ("url(" + (_vm.url.stand) + ")"),
            backgroundPositionX: ((_vm.posX.stand) + "px")
         })})])}
var staticRenderFns = []

export { render, staticRenderFns }